import { Manufacturer } from "interfaces/manufacturer";
import { useLazyFetchV2 } from "hooks/fetch/useLazyFetchV2";

interface LazyFetchResponse {
  count?: number;
  results?: Manufacturer[];
}

interface LazyFetchManufacturer {
  loading: boolean;
  error: boolean;
  fetchCallback: (url: string) => Promise<LazyFetchResponse>;
}

export const useLazyGetManufacturers = (): {
  loading: boolean;
  error: boolean;
  fetchManufacturer: (queryString?: string) => Promise<LazyFetchResponse>;
} => {
  const {
    loading,
    error,
    fetchCallback
  }: LazyFetchManufacturer = useLazyFetchV2("GET");

  return {
    loading,
    error,
    fetchManufacturer: (queryString?: string) =>
      fetchCallback(`manufacturers?${queryString ?? ""}`)
  };
};
